import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=254a4abb&"
import script from "./Legal.vue?vue&type=script&lang=ts&"
export * from "./Legal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports